var _effectorFileName = "/builds/gmini/front-ui-kit/src/SearchInput/SearchInput.tsx";
import React from 'react';
import { Magnifier, RoundedCross } from '../icons';
import { Input, InputWrapper, MagnifierWrapper, RoundedCrossWrapper } from './SearchInput.styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SearchInput = ({
  onChange,
  value,
  placeholder,
  autofocus
}) => /*#__PURE__*/_jsxs(InputWrapper, {
  children: [/*#__PURE__*/_jsx(Input, {
    onChange: event => onChange(event.target.value),
    value: value,
    placeholder: placeholder,
    autoFocus: autofocus
  }), value.length > 0 ? /*#__PURE__*/_jsx(RoundedCrossWrapper, {
    onClick: () => onChange(''),
    children: /*#__PURE__*/_jsx(RoundedCross, {
      color: "#A2A3B7"
    })
  }) : /*#__PURE__*/_jsx(MagnifierWrapper, {
    children: /*#__PURE__*/_jsx(Magnifier, {})
  })]
});